import { format } from "date-fns";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { setUpdateProformaInvoiceDate, setUpdateProformaInvoiceProtocol, setUpdateProformaNumberInvoice, UpdateProforma } from "../../incarichi/inspectionVisit/edit/gestioneRimborsi/slice";

export function PopupProforma() {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const reimbursement = useAppSelector(state => state.reimbursement)

    return (
        <>
            <div className="bg-brandPrimary-100 p-6 flex flex-col gap-6">
                <div className="grid grid-cols-2 gap-6">
                    <MadfarmInput
                        label="Numero fattura"
                        placeholder="Numero Fattura"
                        defaultValue={reimbursement.updateProformaRequest?.invoiceNumber}
                        onChangeText={(text) => dispatch(setUpdateProformaNumberInvoice(text))}
                    />
                    <Calendar
                        label="Data fattura"
                        onClear={(date) => console.log(date)}
                        selected={reimbursement.updateProformaRequest?.invoiceDate}
                        onChange={(date) => dispatch(setUpdateProformaInvoiceDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                </div>
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-600">Protocollo Fattura</span>
                <ProtocolSearch
                    value={reimbursement.updateProformaRequest.invoiceProtocolId ? reimbursement.updateProformaRequest.invoiceProtocolId : undefined}
                    type="entry"
                    onSelect={(value) => dispatch(setUpdateProformaInvoiceProtocol(value))}
                />

            </div>
            <div className="p-6 flex flex-row justify-end w-full items-center gap-2">
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Salva"
                    color="orange"
                    onClick={() =>
                        dispatch(UpdateProforma({
                            body: reimbursement.updateProformaRequest,
                            id: reimbursement.incProformaId
                        }))
                    }
                />
            </div>
        </>

    )
}